var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("CatNicknameDialogBase", {
    attrs: { "on-click-outside": _vm.onClickOutside },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", { staticClass: "dialog-header" }, [
              _c(
                "div",
                { staticClass: "cat-display" },
                [
                  _c("cat-icon", {
                    attrs: {
                      size: "large",
                      clickable: false,
                      "writer-type": _vm.assistantCat?.assistantCatType,
                    },
                  }),
                ],
                1
              ),
              _c("h2", { staticClass: "dialog-title" }, [
                _vm._v(_vm._s(_vm.$t("myPage.catNicknameDialog.title"))),
              ]),
              _c("p", { staticClass: "dialog-subtitle" }, [
                _vm._v(_vm._s(_vm.dialogSubtitle)),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "dialog-body" }, [
              _c("div", { staticClass: "input-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nickname,
                      expression: "nickname",
                    },
                  ],
                  ref: "nicknameInput",
                  staticClass: "nickname-input",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("myPage.catNicknameDialog.placeholder"),
                    maxlength: "30",
                  },
                  domProps: { value: _vm.nickname },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.nickname = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("div", { staticClass: "dialog-footer" }, [
              _c(
                "button",
                { staticClass: "button cancel", on: { click: _vm.onCancel } },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _c("div", { staticClass: "divider" }),
              _c(
                "button",
                { staticClass: "button primary", on: { click: _vm.onSave } },
                [_vm._v(_vm._s(_vm.$t("common.save")))]
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }